import { addLocaleData, IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import heLocaleData from 'react-intl/locale-data/he';
import enLocaleData from 'react-intl/locale-data/en';

import diskEn from './Translations/en.json';
import diskHe from './Translations/he.json';

const heFromTheme = (window.theme && window.theme.locale && window.theme.locale.he) || {};
const enFromTheme = (window.theme && window.theme.locale && window.theme.locale.en) || {};

const he = { ...diskHe, ...heFromTheme };
const en = { ...diskEn, ...enFromTheme };

addLocaleData(heLocaleData);
addLocaleData(enLocaleData);

// This function will map the current redux state to the props for the component that it is "connected" to.
// When the state of the redux store changes, this function will be called, if the props that come out of
// this function are different, then the component that is wrapped is re-rendered.
function mapStateToProps(state) {
	const { lang } = state.identify;
	return { locale: lang, messages: lang === 'he-IL' ? he : en };
}

const LangProvider = connect(mapStateToProps)(IntlProvider);

export {
	he,
	en,
	LangProvider
}
